import React, { useEffect } from 'react';
import { isAuthenticated, login } from '../../utils/keycloak';
import { store } from '../../index';
import * as actionsJourney from '../../actions/journey1';
import SpinnerV2 from '../SpinnerV2';

interface Props {
  component: any;
  beforeLogin?: () => void;
}

export const LoginRequired = ({ component, beforeLogin }: Props) => {
  const [readyToRender, setReadyToRender] = React.useState(false);

  useEffect(() => {
    if (process.env.REACT_APP_MODE === 'django') {
      (window as any).updateHeaderInDjango && (window as any).updateHeaderInDjango();

      setTimeout(() => {
        (window as any).checkKeycloakStatus();
      }, 1000);
    }

    if ((window as any).keycloakReady) {
      if (isAuthenticated()) {
        const storeObj = store.getState();

        if (
          storeObj.app.userDataEC.userInfo === null &&
          !storeObj.app.loading['userinfo'] &&
          Object.keys(storeObj.app.errors).length === 0
        ) {
          store.dispatch(actionsJourney.getUserInfo() as any);
        }

        setReadyToRender(true);
      } else {
        setReadyToRender(false);
        if (beforeLogin) {
          beforeLogin();
        }
        login();
      }
    } else {
      setReadyToRender(false);
    }
  }, [(window as any).keycloakReady]);
  return readyToRender ? component : <SpinnerV2 />;
};
